import styled from 'styled-components/macro';
import { Card } from '@material-ui/core';

interface StyledCardProps {
  fit?: boolean;
}

export const StyledCard = styled(Card)<StyledCardProps>`
  padding: 16px;
  ${({ fit }) => fit && 'width: fit-content'}
`;
